// Auto-generated file created by SVGR source illustrationTemplate.ts
// DO NOT EDIT THIE FILE
import { SVGUniqueID } from './svg-unique-id';
import type { IllustrationProps } from './types';
const Illustration = (props: IllustrationProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    width={149}
    height={99}
    viewBox="0 0 149 99"
    {...props}
  >
    <path
      d="M1.07959 5.46935L1.07959 48.9844L85.1227 48.9844V5.46935L1.07959 5.46935Z"
      fill="#F1F1F3"
      stroke="#C9C8D0"
      strokeWidth={0.16803}
      strokeMiterlimit={10}
    />
    <path
      d="M8.84549 17.7379C10.5411 17.7379 11.9156 16.3633 11.9156 14.6678C11.9156 12.9722 10.5411 11.5977 8.84549 11.5977C7.14992 11.5977 5.77539 12.9722 5.77539 14.6678C5.77539 16.3633 7.14992 17.7379 8.84549 17.7379Z"
      fill="#C9C8D0"
    />
    <path
      d="M8.84549 28.6539C10.5411 28.6539 11.9156 27.2793 11.9156 25.5838C11.9156 23.8882 10.5411 22.5137 8.84549 22.5137C7.14992 22.5137 5.77539 23.8882 5.77539 25.5838C5.77539 27.2793 7.14992 28.6539 8.84549 28.6539Z"
      fill="#C9C8D0"
    />
    <path
      d="M1.07812 5.38877V1.81505C1.07895 1.35464 1.26221 0.913332 1.58777 0.587775C1.91332 0.262218 2.35464 0.0789564 2.81504 0.0781313H83.389C83.6177 0.0775158 83.8442 0.121973 84.0556 0.208947C84.2671 0.295922 84.4593 0.423705 84.6213 0.585013C84.7834 0.746321 84.912 0.937988 85 1.14904C85.0879 1.3601 85.1333 1.58641 85.1338 1.81505V5.38877H1.07812Z"
      fill="#C9C8D0"
    />
    <path
      d="M83.3874 0.156058C83.8273 0.15647 84.2492 0.331341 84.5605 0.642309C84.8717 0.953277 85.047 1.37497 85.0478 1.81495V5.31064H1.15606V1.81495C1.15647 1.37511 1.33138 0.953417 1.64239 0.642404C1.9534 0.331391 2.37511 0.156471 2.81495 0.156058H83.3874ZM83.3874 6.70905e-07H2.81495C2.33359 6.70905e-07 1.87195 0.191222 1.53159 0.53159C1.19122 0.871959 1 1.3336 1 1.81495V5.4667H85.2039V1.81495C85.2039 1.57648 85.1569 1.34035 85.0656 1.12004C84.9743 0.899743 84.8404 0.699592 84.6717 0.531038C84.503 0.362484 84.3028 0.228831 84.0824 0.137713C83.862 0.0465951 83.6258 -0.00020438 83.3874 6.70905e-07Z"
      fill="#C9C8D0"
    />
    <path
      d="M53.3279 11.459H47.6475"
      stroke="#C9C8D0"
      strokeWidth={0.16803}
      strokeMiterlimit={10}
    />
    <path
      d="M80.1183 11.459H56.4429"
      stroke="#C9C8D0"
      strokeWidth={0.16803}
      strokeMiterlimit={10}
    />
    <path
      d="M78.7013 13.4805H47.6475"
      stroke="#C9C8D0"
      strokeWidth={0.16803}
      strokeMiterlimit={10}
    />
    <path
      d="M70.2742 15.5H47.6475"
      stroke="#C9C8D0"
      strokeWidth={0.16803}
      strokeMiterlimit={10}
    />
    <path
      d="M77.0793 15.5H73.0093"
      stroke="#C9C8D0"
      strokeWidth={0.16803}
      strokeMiterlimit={10}
    />
    <path
      d="M80.329 17.5215H47.6475"
      stroke="#C9C8D0"
      strokeWidth={0.16803}
      strokeMiterlimit={10}
    />
    <path
      d="M14.0311 28.5856V22.5819H41.1844V28.5856H14.0311Z"
      stroke="#C9C8D0"
      strokeWidth={0.136449}
    />
    <path
      d="M14.0311 17.6696V11.6659H41.1844V17.6696H14.0311Z"
      stroke="#C9C8D0"
      strokeWidth={0.136449}
    />
    <path
      d="M23.0875 40.1929L21.3396 43.4264C20.8361 43.153 20.4035 42.7655 20.0766 42.295C19.7496 41.8244 19.5374 41.2839 19.4569 40.7166C19.3763 40.1493 19.4297 39.5711 19.6127 39.0281C19.7958 38.4851 20.1034 37.9926 20.5109 37.5898L23.0875 40.1929Z"
      fill="#C9C8D0"
    />
    <path
      d="M23.0877 36.6834C23.7818 36.6834 24.4604 36.8892 25.0376 37.2749C25.6147 37.6605 26.0646 38.2087 26.3302 38.85C26.5959 39.4913 26.6654 40.197 26.53 40.8778C26.3945 41.5587 26.0603 42.184 25.5694 42.6749C25.0786 43.1657 24.4532 43.5 23.7724 43.6354C23.0916 43.7708 22.3859 43.7013 21.7445 43.4357C21.1032 43.1701 20.5551 42.7202 20.1694 42.143C19.7838 41.5659 19.5779 40.8873 19.5779 40.1931C19.5792 39.2627 19.9493 38.3707 20.6073 37.7127C21.2652 37.0548 22.1572 36.6846 23.0877 36.6834ZM23.0877 36.5273C22.3626 36.5273 21.6539 36.7423 21.0511 37.1451C20.4482 37.5479 19.9784 38.1205 19.7009 38.7903C19.4235 39.4601 19.3509 40.1972 19.4923 40.9083C19.6338 41.6194 19.9829 42.2726 20.4956 42.7852C21.0082 43.2979 21.6614 43.647 22.3725 43.7885C23.0836 43.9299 23.8207 43.8573 24.4905 43.5799C25.1603 43.3024 25.7329 42.8326 26.1357 42.2297C26.5385 41.6269 26.7535 40.9182 26.7535 40.1931C26.7537 39.7117 26.659 39.2349 26.4748 38.79C26.2907 38.3452 26.0207 37.941 25.6802 37.6006C25.3398 37.2601 24.9356 36.9901 24.4907 36.806C24.0459 36.6218 23.5691 36.5271 23.0877 36.5273Z"
      fill="#C9C8D0"
    />
    <path
      d="M8.61028 40.5879L7.02449 37.2497C7.54533 37.0034 8.11657 36.8825 8.69251 36.8967C9.26845 36.9108 9.83308 37.0596 10.3412 37.3311C10.8493 37.6026 11.2868 37.9893 11.6187 38.4602C11.9506 38.9311 12.1676 39.4732 12.2523 40.0431L8.61028 40.5879Z"
      fill="#C9C8D0"
    />
    <path
      d="M8.76052 36.9979C9.45468 36.9979 10.1332 37.2037 10.7104 37.5893C11.2876 37.975 11.7374 38.5231 12.0031 39.1645C12.2687 39.8058 12.3382 40.5115 12.2028 41.1923C12.0674 41.8731 11.7331 42.4985 11.2423 42.9893C10.7514 43.4802 10.1261 43.8145 9.44523 43.9499C8.76441 44.0853 8.05872 44.0158 7.4174 43.7502C6.77608 43.4845 6.22794 43.0347 5.84228 42.4575C5.45663 41.8803 5.25079 41.2017 5.25079 40.5076C5.25203 39.5771 5.6222 38.6851 6.28013 38.0272C6.93806 37.3693 7.83006 36.9991 8.76052 36.9979ZM8.76052 36.8418C8.03549 36.8418 7.32675 37.0568 6.72391 37.4596C6.12108 37.8624 5.65123 38.4349 5.37377 39.1047C5.09632 39.7746 5.02372 40.5116 5.16516 41.2227C5.30661 41.9338 5.65574 42.587 6.16841 43.0997C6.68108 43.6123 7.33426 43.9615 8.04536 44.1029C8.75645 44.2444 9.49352 44.1718 10.1634 43.8943C10.8332 43.6169 11.4057 43.147 11.8085 42.5442C12.2113 41.9413 12.4263 41.2326 12.4263 40.5076C12.4265 40.0261 12.3318 39.5493 12.1477 39.1045C11.9635 38.6596 11.6935 38.2555 11.3531 37.915C11.0126 37.5746 10.6084 37.3046 10.1636 37.1204C9.71875 36.9363 9.24197 36.8416 8.76052 36.8418Z"
      fill="#C9C8D0"
    />
    <path
      d="M3.93048 3.91956C4.44761 3.91956 4.86683 3.50035 4.86683 2.98322C4.86683 2.46609 4.44761 2.04688 3.93048 2.04688C3.41336 2.04688 2.99414 2.46609 2.99414 2.98322C2.99414 3.50035 3.41336 3.91956 3.93048 3.91956Z"
      fill="#F1F1F3"
    />
    <path
      d="M7.12687 3.83968C7.6009 3.83968 7.98519 3.4554 7.98519 2.98136C7.98519 2.50733 7.6009 2.12305 7.12687 2.12305C6.65284 2.12305 6.26855 2.50733 6.26855 2.98136C6.26855 3.4554 6.65284 3.83968 7.12687 3.83968Z"
      stroke="#F1F1F3"
      strokeWidth={0.16803}
      strokeMiterlimit={10}
    />
    <path
      d="M79.3296 25.1309C79.9085 25.1418 80.0974 25.599 79.7213 26.331C79.3452 27.0629 78.7412 26.6056 78.7412 26.6056"
      stroke="#C9C8D0"
      strokeWidth={0.16803}
      strokeMiterlimit={10}
    />
    <path
      d="M79.1421 28.9688C79.1421 28.9688 78.5178 29.9831 78.7925 32.079"
      stroke="#C9C8D0"
      strokeWidth={0.16803}
      strokeMiterlimit={10}
    />
    <path
      d="M80.5423 21.832H47.3926V44.6476H80.5423V21.832Z"
      fill="#F1F1F3"
      stroke="#C9C8D0"
      strokeWidth={0.16803}
      strokeMiterlimit={10}
    />
    <path
      d="M59.9008 32.8867H56.3521V43.4159H59.9008V32.8867Z"
      fill="#9B9AA2"
    />
    <path
      d="M79.1879 32.8867H75.6392V43.4159H79.1879V32.8867Z"
      fill="#9B9AA2"
    />
    <path
      d="M64.7152 35.6113H61.1665V43.4173H64.7152V35.6113Z"
      fill="#9B9AA2"
    />
    <path
      d="M55.0844 36.9863H51.5356V43.4175H55.0844V36.9863Z"
      fill="#9B9AA2"
    />
    <path
      d="M69.5307 27.9668H65.9819V43.4165H69.5307V27.9668Z"
      fill="#9B9AA2"
    />
    <path
      d="M74.3451 34.9551H70.7964V43.4165H74.3451V34.9551Z"
      fill="#9B9AA2"
    />
    <path
      d="M48.5566 28.2422H49.6537"
      stroke="#C9C8D0"
      strokeWidth={0.16803}
      strokeMiterlimit={10}
    />
    <path
      d="M48.5566 33.3145H49.6537"
      stroke="#C9C8D0"
      strokeWidth={0.16803}
      strokeMiterlimit={10}
    />
    <path
      d="M48.5566 38.3887H49.6537"
      stroke="#C9C8D0"
      strokeWidth={0.16803}
      strokeMiterlimit={10}
    />
    <path
      d="M49.6553 43.4605H48.5566V23.1699H49.6553"
      stroke="#C9C8D0"
      strokeWidth={0.16803}
      strokeMiterlimit={10}
    />
    <path
      d="M37.4596 40.1924L39.877 37.427C40.5165 37.985 40.9427 38.7475 41.0832 39.5845C41.2236 40.4215 41.0695 41.2813 40.6471 42.0174C40.2247 42.7536 39.5602 43.3205 38.7667 43.6217C37.9732 43.9228 37.0999 43.9396 36.2954 43.6691C35.491 43.3986 34.8052 42.8576 34.3549 42.1382C33.9046 41.4188 33.7176 40.5655 33.8259 39.7237C33.9341 38.8819 34.3308 38.1037 34.9484 37.5216C35.566 36.9395 36.3664 36.5895 37.2131 36.5312L37.4596 40.1924Z"
      fill="#C9C8D0"
    />
    <path
      d="M37.4551 36.6834C38.1493 36.6831 38.828 36.8887 39.4054 37.2741C39.9828 37.6596 40.4329 38.2076 40.6987 38.8489C40.9646 39.4902 41.0343 40.196 40.8991 40.8769C40.7638 41.5578 40.4297 42.1833 39.9389 42.6743C39.4481 43.1653 38.8228 43.4998 38.1419 43.6353C37.461 43.7709 36.7553 43.7014 36.1139 43.4358C35.4725 43.1702 34.9242 42.7204 34.5385 42.1432C34.1528 41.566 33.9469 40.8874 33.9469 40.1931C33.9481 39.2627 34.3183 38.3707 34.9762 37.7127C35.6342 37.0548 36.5262 36.6846 37.4566 36.6834H37.4551ZM37.4566 36.5273C36.7317 36.528 36.0233 36.7435 35.4209 37.1467C34.8184 37.5498 34.3491 38.1226 34.0721 38.7924C33.7951 39.4623 33.723 40.1993 33.8648 40.9102C34.0066 41.6211 34.3559 42.274 34.8687 42.7863C35.3815 43.2987 36.0347 43.6475 36.7457 43.7887C37.4567 43.9299 38.1936 43.8571 38.8633 43.5796C39.5329 43.302 40.1053 42.8322 40.5079 42.2294C40.9106 41.6266 41.1255 40.918 41.1255 40.1931C41.1257 39.7117 41.031 39.2349 40.8469 38.79C40.6627 38.3452 40.3927 37.941 40.0523 37.6006C39.7119 37.2601 39.3077 36.9901 38.8628 36.806C38.418 36.6218 37.9412 36.5271 37.4597 36.5273H37.4566Z"
      fill="#C9C8D0"
    />
    <path
      d="M46.0298 57.7694V98.1211H123.963V57.7694L46.0298 57.7694Z"
      fill="#F1F1F3"
      stroke="#C9C8D0"
      strokeWidth={0.155815}
      strokeMiterlimit={10}
    />
    <path
      d="M46.0283 57.6961V54.3821C46.0291 53.9552 46.199 53.546 46.5009 53.2441C46.8028 52.9422 47.212 52.7723 47.639 52.7715H122.356C122.568 52.7709 122.778 52.8121 122.974 52.8928C123.17 52.9734 123.348 53.0919 123.498 53.2415C123.649 53.3911 123.768 53.5688 123.849 53.7646C123.931 53.9603 123.973 54.1701 123.974 54.3821V57.6961H46.0283Z"
      fill="#C9C8D0"
    />
    <path
      d="M122.354 52.8439C122.762 52.8443 123.153 53.0065 123.442 53.2948C123.731 53.5832 123.893 53.9742 123.894 54.3822V57.6238H46.1008V54.3822C46.1012 53.9744 46.2633 53.5833 46.5517 53.2949C46.8402 53.0065 47.2312 52.8443 47.6391 52.8439H122.354ZM122.354 52.6992H47.6391C47.1927 52.6992 46.7646 52.8765 46.449 53.1922C46.1334 53.5078 45.9561 53.9359 45.9561 54.3822V57.7685H124.039V54.3822C124.039 54.1611 123.995 53.9421 123.91 53.7378C123.826 53.5336 123.702 53.348 123.545 53.1917C123.389 53.0354 123.203 52.9114 122.999 52.8269C122.794 52.7424 122.575 52.699 122.354 52.6992Z"
      fill="#C9C8D0"
    />
    <path
      d="M94.4795 69.0332H89.2119"
      stroke="#C9C8D0"
      strokeWidth={0.155815}
      strokeMiterlimit={10}
    />
    <path
      d="M119.323 69.0332H97.3682"
      stroke="#C9C8D0"
      strokeWidth={0.155815}
      strokeMiterlimit={10}
    />
    <path
      d="M118.008 70.9082H89.2119"
      stroke="#C9C8D0"
      strokeWidth={0.155815}
      strokeMiterlimit={10}
    />
    <path
      d="M110.194 72.7793H89.2119"
      stroke="#C9C8D0"
      strokeWidth={0.155815}
      strokeMiterlimit={10}
    />
    <path
      d="M116.505 72.7793H112.731"
      stroke="#C9C8D0"
      strokeWidth={0.155815}
      strokeMiterlimit={10}
    />
    <path
      d="M119.518 74.6543H89.2119"
      stroke="#C9C8D0"
      strokeWidth={0.155815}
      strokeMiterlimit={10}
    />
    <path
      d="M94.4795 76.8828H89.2119"
      stroke="#C9C8D0"
      strokeWidth={0.155815}
      strokeMiterlimit={10}
    />
    <path
      d="M119.323 76.8828H97.3682"
      stroke="#C9C8D0"
      strokeWidth={0.155815}
      strokeMiterlimit={10}
    />
    <path
      d="M118.008 78.7578H89.2119"
      stroke="#C9C8D0"
      strokeWidth={0.155815}
      strokeMiterlimit={10}
    />
    <path
      d="M110.194 80.6289H89.2119"
      stroke="#C9C8D0"
      strokeWidth={0.155815}
      strokeMiterlimit={10}
    />
    <path
      d="M116.505 80.6289H112.731"
      stroke="#C9C8D0"
      strokeWidth={0.155815}
      strokeMiterlimit={10}
    />
    <path
      d="M119.518 82.5039H89.2119"
      stroke="#C9C8D0"
      strokeWidth={0.155815}
      strokeMiterlimit={10}
    />
    <path
      d="M51.0144 91.883V69.1746H82.9996V91.883H51.0144Z"
      stroke="#C9C8D0"
      strokeWidth={0.12653}
    />
    <path
      d="M48.673 56.3342C49.1525 56.3342 49.5412 55.9455 49.5412 55.4659C49.5412 54.9864 49.1525 54.5977 48.673 54.5977C48.1934 54.5977 47.8047 54.9864 47.8047 55.4659C47.8047 55.9455 48.1934 56.3342 48.673 56.3342Z"
      fill="#F1F1F3"
    />
    <path
      d="M51.6372 56.2598C52.0768 56.2598 52.4331 55.9035 52.4331 55.4639C52.4331 55.0243 52.0768 54.668 51.6372 54.668C51.1977 54.668 50.8413 55.0243 50.8413 55.4639C50.8413 55.9035 51.1977 56.2598 51.6372 56.2598Z"
      stroke="#F1F1F3"
      strokeWidth={0.155815}
      strokeMiterlimit={10}
    />
    <path
      d="M119.456 91.947L119.456 86.2383L89.4852 86.2383L89.4852 91.947L119.456 91.947Z"
      fill="#9B9AA2"
    />
    <path
      d="M89.5405 18.6709V48.9102L147.943 48.9102V18.6709L89.5405 18.6709Z"
      fill="#F1F1F3"
      stroke="#C9C8D0"
      strokeWidth={0.116767}
      strokeMiterlimit={10}
    />
    <path
      d="M89.5396 18.6162V16.1328C89.5401 15.8129 89.6675 15.5062 89.8937 15.2799C90.1199 15.0537 90.4266 14.9264 90.7466 14.9258H146.739C146.898 14.9254 147.055 14.9563 147.202 15.0167C147.349 15.0771 147.482 15.1659 147.595 15.278C147.708 15.3901 147.797 15.5233 147.858 15.67C147.919 15.8166 147.951 15.9739 147.951 16.1328V18.6162H89.5396Z"
      fill="#C9C8D0"
    />
    <path
      d="M146.738 14.9795C147.043 14.9798 147.337 15.1013 147.553 15.3174C147.769 15.5335 147.891 15.8266 147.891 16.1323V18.5615H89.5938V16.1323C89.5941 15.8267 89.7156 15.5336 89.9318 15.3175C90.1479 15.1014 90.4409 14.9798 90.7466 14.9795H146.738ZM146.738 14.8711H90.7466C90.4121 14.8711 90.0913 15.004 89.8548 15.2405C89.6182 15.477 89.4854 15.7978 89.4854 16.1323V18.67H148V16.1323C148 15.9666 147.967 15.8025 147.904 15.6494C147.84 15.4963 147.747 15.3573 147.63 15.2401C147.513 15.123 147.374 15.0301 147.221 14.9668C147.067 14.9035 146.903 14.871 146.738 14.8711Z"
      fill="#C9C8D0"
    />
    <path
      d="M100.911 32.8384V22.9771H119.78V32.8384H100.911Z"
      stroke="#C9C8D0"
      strokeWidth={0.0948203}
    />
    <path
      d="M119.828 32.8854L119.828 30.0977L100.864 30.0977L100.864 32.8854L119.828 32.8854Z"
      fill="#9B9AA2"
    />
    <path
      d="M122.72 32.8384V22.9771H141.589V32.8384H122.72Z"
      stroke="#C9C8D0"
      strokeWidth={0.0948203}
    />
    <path
      d="M141.637 32.8854L141.637 30.0977L122.673 30.0977L122.673 32.8854L141.637 32.8854Z"
      fill="#9B9AA2"
    />
    <path
      d="M100.911 44.6919V34.8306H119.78V44.6919H100.911Z"
      stroke="#C9C8D0"
      strokeWidth={0.0948203}
    />
    <path
      d="M119.828 44.7389L119.828 41.9512L100.864 41.9512L100.864 44.7389L119.828 44.7389Z"
      fill="#9B9AA2"
    />
    <path
      d="M122.72 44.6919V34.8306H141.589V44.6919H122.72Z"
      stroke="#C9C8D0"
      strokeWidth={0.0948203}
    />
    <path
      d="M141.637 44.7389L141.637 41.9512L122.673 41.9512L122.673 44.7389L141.637 44.7389Z"
      fill="#9B9AA2"
    />
    <path
      d="M91.5218 17.5943C91.8811 17.5943 92.1725 17.303 92.1725 16.9436C92.1725 16.5843 91.8811 16.293 91.5218 16.293C91.1624 16.293 90.8711 16.5843 90.8711 16.9436C90.8711 17.303 91.1624 17.5943 91.5218 17.5943Z"
      fill="#F1F1F3"
    />
    <path
      d="M93.7429 17.5406C94.0724 17.5406 94.3394 17.2735 94.3394 16.9441C94.3394 16.6147 94.0724 16.3477 93.7429 16.3477C93.4135 16.3477 93.1465 16.6147 93.1465 16.9441C93.1465 17.2735 93.4135 17.5406 93.7429 17.5406Z"
      stroke="#F1F1F3"
      strokeWidth={0.116767}
      strokeMiterlimit={10}
    />
    <rect
      x={94.4732}
      y={23.3228}
      width={4.3462}
      height={22.62}
      rx={2.1731}
      stroke="#C9C8D0"
      strokeWidth={0.0987773}
    />
    <rect
      x={119.407}
      y={63.4517}
      width={4.18278}
      height={68.4061}
      rx={2.09139}
      transform="rotate(90 119.407 63.4517)"
      stroke="#C9C8D0"
      strokeWidth={0.0987773}
    />
    <line
      x1={96.6461}
      y1={42.7824}
      x2={96.6461}
      y2={26.978}
      stroke="#9B9AA2"
      strokeWidth={0.493887}
      strokeLinecap="round"
    />
    <circle
      cx={96.6463}
      cy={34.3851}
      r={0.987773}
      fill="#C9C8D0"
      stroke="#9B9AA2"
      strokeWidth={0.493887}
    />
    <g clipPath="url(#clip0_4271_48372)">
      <rect
        x={63.7959}
        y={14.875}
        width={49.9515}
        height={49.9515}
        rx={24.9757}
        fill="white"
      />
      <path
        d="M0.923828 5.30713L0.923828 48.9512L85.2161 48.9512V5.30713L0.923828 5.30713Z"
        fill="white"
        stroke="#29292F"
        strokeWidth={0.168528}
        strokeMiterlimit={10}
      />
      <path
        d="M70.3232 15.3672H47.6294"
        stroke="#29292F"
        strokeWidth={0.168528}
        strokeMiterlimit={10}
      />
      <path
        d="M77.1494 15.3672H73.0674"
        stroke="#29292F"
        strokeWidth={0.168528}
        strokeMiterlimit={10}
      />
      <path
        d="M80.4078 17.3945H47.6294"
        stroke="#29292F"
        strokeWidth={0.168528}
        strokeMiterlimit={10}
      />
      <path
        d="M79.4065 25.0273C79.9872 25.0383 80.1766 25.4969 79.7994 26.231C79.4221 26.9651 78.8164 26.5065 78.8164 26.5065"
        stroke="#29292F"
        strokeWidth={0.168528}
        strokeMiterlimit={10}
      />
      <path
        d="M79.2185 28.877C79.2185 28.877 78.5924 29.8943 78.8679 31.9964"
        stroke="#29292F"
        strokeWidth={0.168528}
        strokeMiterlimit={10}
      />
      <path
        d="M80.6225 21.7188H47.3745V44.602H80.6225V21.7188Z"
        fill="white"
        stroke="#29292F"
        strokeWidth={0.168528}
        strokeMiterlimit={10}
      />
      <path
        d="M79.2639 32.8066H75.7046V43.3671H79.2639V32.8066Z"
        fill="#37363F"
      />
      <path
        d="M64.7487 35.5371H61.1895V43.3662H64.7487V35.5371Z"
        fill="#37363F"
      />
      <path
        d="M69.5783 27.8711H66.019V43.3666H69.5783V27.8711Z"
        fill="#37363F"
      />
      <path
        d="M74.4069 34.8809H70.8477V43.3674H74.4069V34.8809Z"
        fill="#37363F"
      />
      <path
        d="M47.4448 57.373V96.0664H122.176V57.373L47.4448 57.373Z"
        fill="white"
        stroke="#29292F"
        strokeWidth={0.149412}
        strokeMiterlimit={10}
      />
      <path
        d="M47.4429 57.3042V54.1265C47.4436 53.7171 47.6066 53.3247 47.896 53.0352C48.1855 52.7457 48.5779 52.5828 48.9873 52.582H120.633C120.837 52.5815 121.038 52.621 121.226 52.6984C121.414 52.7757 121.585 52.8893 121.729 53.0328C121.873 53.1762 121.988 53.3466 122.066 53.5343C122.144 53.722 122.184 53.9232 122.185 54.1265V57.3042H47.4429Z"
        fill="#29292F"
      />
      <path
        d="M120.633 52.6505C121.024 52.6509 121.399 52.8063 121.676 53.0829C121.952 53.3594 122.108 53.7343 122.109 54.1256V57.2339H47.5128V54.1256C47.5132 53.7345 47.6687 53.3595 47.9452 53.0829C48.2218 52.8064 48.5968 52.6509 48.9879 52.6505H120.633ZM120.633 52.5117H48.9879C48.5598 52.5117 48.1494 52.6818 47.8467 52.9844C47.5441 53.2871 47.374 53.6975 47.374 54.1256V57.3727H122.248V54.1256C122.248 53.9135 122.206 53.7035 122.125 53.5077C122.044 53.3118 121.925 53.1338 121.775 52.9839C121.625 52.834 121.447 52.7152 121.251 52.6342C121.055 52.5532 120.845 52.5115 120.633 52.5117Z"
        fill="#29292F"
      />
      <path
        d="M89.1685 18.6742V48.8809L147.508 48.8809V18.6742L89.1685 18.6742Z"
        fill="white"
        stroke="#29292F"
        strokeWidth={0.116641}
        strokeMiterlimit={10}
      />
      <path
        d="M89.1675 18.6181V16.1374C89.1681 15.8178 89.2953 15.5114 89.5213 15.2854C89.7472 15.0594 90.0536 14.9322 90.3732 14.9316H146.305C146.464 14.9312 146.621 14.9621 146.768 15.0225C146.914 15.0828 147.048 15.1715 147.16 15.2835C147.273 15.3955 147.362 15.5285 147.423 15.675C147.484 15.8215 147.516 15.9786 147.516 16.1374V18.6181H89.1675Z"
        fill="#29292F"
      />
      <path
        d="M146.304 14.9853C146.609 14.9856 146.902 15.107 147.118 15.3228C147.334 15.5387 147.456 15.8314 147.456 16.1368V18.5634H89.2216V16.1368C89.2219 15.8315 89.3433 15.5388 89.5592 15.3229C89.7751 15.107 90.0678 14.9856 90.3732 14.9853H146.304ZM146.304 14.877H90.3732C90.039 14.877 89.7186 15.0097 89.4823 15.246C89.246 15.4822 89.1133 15.8027 89.1133 16.1368V18.6717H147.565V16.1368C147.565 15.9713 147.532 15.8074 147.469 15.6544C147.405 15.5015 147.312 15.3626 147.195 15.2456C147.078 15.1286 146.939 15.0358 146.786 14.9725C146.633 14.9093 146.469 14.8768 146.304 14.877Z"
        fill="#29292F"
      />
      <path
        d="M100.527 32.8258V22.9751H119.376V32.8258H100.527Z"
        stroke="black"
        strokeWidth={0.094718}
      />
      <path
        d="M119.423 32.8726L119.423 30.0879L100.48 30.0879L100.48 32.8726L119.423 32.8726Z"
        fill="#37363F"
      />
      <path
        d="M100.527 44.6656V34.8149H119.376V44.6656H100.527Z"
        stroke="black"
        strokeWidth={0.094718}
      />
      <path
        d="M119.423 44.7124L119.423 41.9277L100.48 41.9277L100.48 44.7124L119.423 44.7124Z"
        fill="#37363F"
      />
      <path
        d="M91.1475 17.5968C91.5065 17.5968 91.7975 17.3058 91.7975 16.9469C91.7975 16.5879 91.5065 16.2969 91.1475 16.2969C90.7886 16.2969 90.4976 16.5879 90.4976 16.9469C90.4976 17.3058 90.7886 17.5968 91.1475 17.5968Z"
        fill="white"
      />
      <path
        d="M93.3663 17.5432C93.6954 17.5432 93.9621 17.2764 93.9621 16.9474C93.9621 16.6183 93.6954 16.3516 93.3663 16.3516C93.0373 16.3516 92.7705 16.6183 92.7705 16.9474C92.7705 17.2764 93.0373 17.5432 93.3663 17.5432Z"
        stroke="white"
        strokeWidth={0.116641}
        strokeMiterlimit={10}
      />
      <rect
        x={93.8965}
        y={22.9751}
        width={4.16759}
        height={21.6904}
        rx={2.0838}
        stroke="black"
        strokeWidth={0.094718}
      />
      <rect
        x={117.805}
        y={61.4556}
        width={4.01088}
        height={65.5949}
        rx={2.00544}
        transform="rotate(90 117.805 61.4556)"
        stroke="black"
        strokeWidth={0.094718}
      />
      <line
        x1={95.98}
        y1={41.6343}
        x2={95.98}
        y2={26.4794}
        stroke="#37363F"
        strokeWidth={0.47359}
        strokeLinecap="round"
      />
      <circle
        cx={95.9799}
        cy={33.5844}
        r={0.94718}
        fill="#29292F"
        stroke="#37363F"
        strokeWidth={0.47359}
      />
    </g>
    <defs>
      <clipPath id="clip0_4271_48372">
        <rect
          x={63.7959}
          y={14.875}
          width={49.9515}
          height={49.9515}
          rx={24.9757}
          fill="white"
        />
      </clipPath>
    </defs>
  </svg>
);
const SvgToursMinimal = (props: IllustrationProps) => (
  <SVGUniqueID>{Illustration(props)}</SVGUniqueID>
);
export default SvgToursMinimal;
